import { Box, Checkbox, FormControlLabel } from "@mui/material"
import type { FC } from "react"
import { useFormContext } from "react-hook-form"

import { ACCOUNT_CLASSIFICATION_LABELS } from "../../constants"
import type { ChartOfAccountsSearchParams } from "../../types/searchParams"

import { GlAccountClassification } from "@/graphql/codegen/graphql"

const classificationList = Object.values(GlAccountClassification)

interface ClassificationFilterProps {
  onFilterChange: (name: keyof ChartOfAccountsSearchParams, value: unknown) => void
}

export const ClassificationFilter: FC<ClassificationFilterProps> = ({ onFilterChange }) => {
  const { watch, setValue } = useFormContext()
  const classificationValue = watch("classification")

  const handleCheckboxChange = (classification: GlAccountClassification) => {
    // Radio button behavior: if clicking the same one, uncheck it; otherwise select the new one
    const newValue = classificationValue === classification ? undefined : classification
    setValue("classification", newValue)
    onFilterChange("classification", newValue)
  }

  return (
    <Box className='flex-1 overflow-y-auto overflow-x-hidden px-8'>
      {classificationList.map((classification) => (
        <FormControlLabel
          key={classification}
          control={
            <Checkbox
              checked={classificationValue === classification}
              onChange={() => handleCheckboxChange(classification)}
            />
          }
          label={ACCOUNT_CLASSIFICATION_LABELS[classification]}
          className='w-full text-ellipsis'
        />
      ))}
    </Box>
  )
}
